<template>
  <div style="height: 100%">
    <div style="display: flex; width: 100%">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.aahRepairDes" style="width: 130px" size="small" placeholder="请输入资产"></el-input>
          <el-select v-model="formDatas.aahType" clearable placeholder="请选择" @change="partserch" size="small"
            style="width: 130px">
            <el-option label="设备" :value="1" key="1"></el-option>
            <el-option label="配件" :value="2" key="2"></el-option>

          </el-select>
          <el-select v-model="formDatas.aahStatus" clearable placeholder="请选择" @change="partserch" size="small"
            style="width: 130px">
            <el-option label="待处理" :value="1" key="1"></el-option>
            <el-option label="已处理" :value="2" key="2"></el-option>
            <el-option label="已删除" :value="3" key="3"></el-option>
          </el-select>

          <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
            v-if="post == 2" style="width: 130px">
            <el-option label="已删除" :value="2" key="2"></el-option>
            <el-option label="未删除" :value="1" key="1"></el-option>
          </el-select>
          <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
          <el-dropdown size="small" split-button type="warning" style="margin-left: 10px;" @click="Out()"
            @command="Out">
            导出
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="background-color: #E6A23C;color: white;" command="1">导出全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
          <!-- <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增配件分类</el-button> -->

          <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption" row-key-field-name="aahId" :cellSelectionOption="cellSelectionOption"
            style="width: 100%" :editOption="editOption" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 新增 -->
      <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑配件分类' : '新增配件分类'" :before-close="handleClose"
        :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
        <div class="demo-drawer__content" style="height: 90%;">
          <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
            <div style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
              <el-form-item label="配件分类" prop="afcName">
                <el-input v-model="form.aahRepairTime" style="width: 50%;" placeholder="请输入名称"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="demo-drawer__footer" style="margin-top: 10px;">
          <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
          <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
            确 定</el-button>
        </div>
      </el-drawer>
      <!-- 处理故障 -->
      <el-dialog title="处理故障" :visible.sync="BreakDown" width="70%" top="15vh">
        <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
          <el-form-item label="维修时间" prop="aahRepairTime">
            <el-date-picker v-model="form.aahRepairTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="维修说明" prop="aahRepairDes">
            <el-input v-model="form.aahRepairDes" style="width: 50%;" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="维修价格" prop="aahRepairMoney">
            <el-input v-model="form.aahRepairMoney" style="width: 50%;" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="维修方式" prop="aahRepairType">
            <el-select v-model="form.aahRepairType" clearable placeholder="请选择" style="width: 130px">
              <el-option label="公司承担" value="公司承担" key="1"></el-option>
              <el-option label="在保维修" value="在保维修" key="2"></el-option>
              <el-option label="人为自费" value="人为自费" key="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="aahStatus">
            <el-select v-model="form.aahStatus" clearable placeholder="请选择" style="width: 130px">
              <el-option label="待处理" :value="1" key="1"></el-option>
              <el-option label="已处理" :value="2" key="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="CloseBreakDown">取 消</el-button>
          <el-button type="primary" @click="sureBreakDown">确 定</el-button>
        </span>
      </el-dialog>

    </div>
  </div>
</template>

<script>

import { getAjAssetsHitchList, addAjFittingsClass, updateAjFittingsClass, deleteAjAssetsHitch, updateAjAssetsHitch,exportAjAssetsHitch } from "../../api/api";
export default {
  name: "",
  components: {},
  data() {
    return {
      BreakDown: false,//处理故障
      dialog: false,
      edit: false,
      form: {
        aahId: '',
      },
      rules: {},
      // 未编辑前的值
      lastValue: "",
      // 单元格编辑功能
      editOption: {
        beforeCellValueChange: ({ row, column, changeValue }) => {

          this.beforeCellValChange(row, column, changeValue);
        },
        afterCellValueChange: ({ row, column, changeValue }) => {
          this.afterCellValChange(row, column, changeValue);
        },
      },
      cellSelectionOption: {
        // disble cell selection
        enable: true,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 10,
      selectedRowKeysCollection: [],
      checkboxOption: {
        // 可控属性
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      windheight: "",
      tableHight: 520,
      columns: [
        {
          field: "",
          key: "checkbox",
          // type=checkbox
          type: "checkbox",

          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "aahType",
          key: "aahType",
          title: "类型",
          align: "center",

          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button
                  size="mini"
                  type="text"

                >
                  {row.aahType == 1 ? '设备' : '配件'}
                </el-button>

              </span>
            );
          },
        },
        {
          field: "auName",
          key: "auName",
          title: "人员",
          align: "center",
        },
        {
          field: "aahThisNumber",
          key: "aahThisNumber",
          title: "设备编码",
          align: "center",
        },
        {
          field: "aahThisName",
          key: "aahThisName",
          title: "故障资产",
          align: "center",
        },
        {
          field: "aahDes",
          key: "aahDes",
          title: "故障描述",
          align: "center",
        },
        {
          field: "aahRepairMoney",
          key: "aahRepairMoney",
          title: "维修价格",
          align: "center",

          // fixed:'left',

        },
        {
          field: "aahRepairType",
          key: "aahRepairType",
          title: "维修方式",
          align: "center",
        },
        {
          field: "aahRepairDes",
          key: "aahRepairDes",
          title: "维修说明",
          align: "center",
        },
        {
          field: "aahStatus",
          key: "aahStatus",
          title: "状态",
          align: "center",

          // fixed:'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.aahStatus == 1 ? <el-tag size="mini" type="danger" > 待处理 </el-tag> : row.aahStatus == 2
                    ? <el-tag size="mini" type="success" > 已处理 </el-tag> : <el-tag size="mini" type="info" > 已删除 </el-tag>
                }


              </span>
            );
          },

        },
        { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 120,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.aahStatus == 1 ? <el-button

                    size="mini"
                    type="text"
                    on-click={() => this.handleEdit(row)}
                  >
                    处理
                  </el-button> : <span></span>
                }
                {
                  row.aahStatus == 1 ? <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.handleDelete(row)}
                  >
                    删除
                  </el-button> : <span></span>
                }

              </span>
            );
          },
        },
      ], //表格的列
      tableData: [],
      post: null,
      formDatas: {
        dmDelete: 1,
        currentPage: 1,
        pageSize: 10,
      },
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.windheight = this.$store.state.windheight
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.getList();
  },
  mounted() { },
  methods: {
    openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
    Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                this.openLoading()
                exportAjAssetsHitch({ aahIds: this.selectedRowKeysCollection.toString(),exportType:2,...this.formDatas }).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });
                        this.checkboxOption.selectedRowKeys = this.selectedRowKeysCollection = []

                    }
                })
            } else {
                this.openLoading()
                this.formDatas.exportType = 1
                exportAjAssetsHitch(this.formDatas).then(res => {
                    if (res.status == 200) {
                        this.loadings.close()
                        window.location.href = res.data;
                        this.$message({
                            type: "success",
                            message: '导出成功',
                        });


                    }
                })
            }
        },
    // 处理故障
    CloseBreakDown() {
      this.BreakDown = false;

      this.$refs['formRef'].resetFields();
    },
    sureBreakDown() {
      this.$confirm("是否确定要处理故障吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateAjAssetsHitch(this.form).then(res => {
            if (res.data) {
              this.CloseBreakDown();
              this.getList()
              this.$message({
                type: "success",
                message: "处理成功!",
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })

    },
    handleDelete(row) {
      this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {

          deleteAjAssetsHitch({ aahIds: row.aahId }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });

              this.partserch()
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    handleEdit(row) {
      this.form.aahId = row.aahId;
      this.BreakDown = true;
    },
    SureBtn() {
      if (!this.edit) {
        this.$confirm("是否确定要新增, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            addAjFittingsClass(this.form).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.handleClose()
                this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      } else {
        this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            updateAjFittingsClass(this.form).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.handleClose()
                this.getList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      }

    },
    BoxOpen() {
      this.dialog = true;

    },
    // 关闭弹框
    handleClose() {
      this.dialog = false;
      this.edit = false;
      this.$refs['formRef'].resetFields();
    },
    // 修改单元格
    async beforeCellValChange(row, column, changeValue) {

      if (row[column.field] == changeValue) {
        return false;
      }

      this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var jsonObj = {};
          let formData = new FormData();
          formData.append(column.field, changeValue);
          formData.forEach((value, key) => (jsonObj[key] = value));
          jsonObj.aahId = row.aahId
          console.log(jsonObj);
          updateAjFittingsClass(jsonObj).then(res => {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
          })

        })
        .catch(() => {
          this.lastValue = row[column.field];
          this.$nextTick(() => {
            this.tableData.forEach((item) => {
              for (let key in item) {
                if (key == column.field && item[key] == changeValue) {
                  item[key] = this.lastValue;
                }
                console.log(key);
              }
            });
          });
          this.$message({
            type: "info",
            message: "已取消编辑",
          });
          return false;
        });
    },
    afterCellValChange(row, column, changeValue) {
      // console.log(" afterCellValChange", row, column, changeValue);
    },
    // reset selectedRowKeys
    resetSelectedRowKeys() {
      console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      this.checkboxOption.selectedRowKeys = [];

      const selectedRowKeysCollection = this.selectedRowKeysCollection;

      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item.aahId) > -1) {
            console.log(item);
            this.checkboxOption.selectedRowKeys.push(item.aahId);
          }
        });
      }
    },
    // select all change
    changeSelectAll(isSelected, selectedRowKeys) {
      console.log(isSelected, selectedRowKeys);
      this.checkboxOption.selectedRowKeys = selectedRowKeys;

      if (isSelected) {
        this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
      } else {
        this.tableData.forEach((item, index) => {
          if (this.selectedRowKeysCollection.indexOf(item.aahId) > -1) {
            this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item.aahId), 1);
          }
        });
      }
    },
    changeSelectedRowKeys(row, isSelected) {
      const rowKey = row.aahId;

      if (isSelected) {
        this.checkboxOption.selectedRowKeys.push(rowKey);
        this.selectedRowKeysCollection.push(rowKey);
        console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      } else {
        const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
        this.checkboxOption.selectedRowKeys.splice(index, 1);
        this.selectedRowKeysCollection.splice(index, 1);
      }
    },
    pageSizeChange(pageSize) {

      this.formDatas.pageSize = pageSize;
      this.partserch();


    },
    pageNumberChange(pageIndex) {
      console.log(pageIndex);
      this.formDatas.currentPage = pageIndex;
      getAjAssetsHitchList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
        // this.$message({
        //   type: "success",
        //   message: "搜索成功!",
        // });
      });

    },
    partserch() {
      this.formDatas.currentPage = 1;
      getAjAssetsHitchList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
        // this.$message({
        //   type: "success",
        //   message: "搜索成功!",
        // });
      });
    },
    getList() {
      getAjAssetsHitchList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
      });
    },
  },
};
</script>

<style>
.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
  display: none;
}

.ve-table-container {
  height: auto !important;
}
</style>